import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { MdKeyboardArrowRight, MdOutlineStarPurple500 } from "react-icons/md";
import { FaRegHeart, FaHeart } from "react-icons/fa";
import { useWishlistContext } from "../../Context/WishlistContext";
import { useCartContext } from "../../Context/CartContext";
import { toast } from "react-toastify";
import img2 from "../../images/kidsSocks.jpg";
import { RxMagnifyingGlass } from "react-icons/rx";
import axios from "axios";
import { BASE_URL } from "../../constant";
import { FaRegStar, FaStar } from "react-icons/fa6";

const ProductsContainer = ({
  searchTerm,
  currentProducts,
  setCurrentProducts,
  values,
  sortByAlphabatically,
  stockStatus,
  currentSubcategory,
  scheme,
  openingCategory,
  shape,
  isButtonClicked,
  tempValues,
  isFiltered,
  isFilterClicked,
  selectedCategory,
}) => {
  const location = useLocation();
  const [currentPage, setCurrentPage] = useState(1);
  // const [visiblePages, setVisiblePages] = useState(5);
  const productsPerPage = 9;
  const [cartItems, setCartItems] = useState([]);
  const [wishlistItems, setWishlistItems] = useState([]);
  const { fetchCartCount } = useCartContext();
  const { fetchWishlistCount } = useWishlistContext();
  const navigate = useNavigate();
  const isInitialMount = useRef(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  // const { productId } = useParams();
  // const [productDetails, setProductDetails] = useState(null);
  // const [reviews, setReviews] = useState([]);
  const queryParams = new URLSearchParams(location.search);
  const [loading, setLoading] = useState(false);
  const [visibleCards, setVisibleCards] = useState(9);
  const category = queryParams.get("category");
  const subcategory = queryParams.get("subcategory");

  if (isFilterClicked) {
    // console.log("button clicked");
  }

  const handleLoadMore = () => {
    setVisibleCards(currentProducts.length);
  };

  // console.log("scheme", scheme);

  const openModal = (imageSrc) => {
    setSelectedImage(imageSrc);
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedImage(null);
  };

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      setLoading(true);
      fetchAllProducts();
    }
  }, [
    searchTerm,
    stockStatus,
    values,
    scheme,
    openingCategory,
    category,
    subcategory,
    isFiltered,
    isFilterClicked,
  ]);
  useEffect(() => {
    fetchCartItems();
    fetchWishlistItems();
    fetchWishlistCount();
  }, []);

  useEffect(() => {
    setLoading(true);
  }, []);

  const fetchAllProducts = async () => {
    try {
      setLoading(true); // Indicate loading state
      const userId = localStorage.getItem("userId");

      let endpoint;

      // Build endpoint based on multiple criteria
      if (category && scheme === "offered") {
        endpoint = `${BASE_URL}/api/customProducts/offer-products`;
      } else if (category && scheme === "lightning") {
        endpoint = `${BASE_URL}/api/customProducts/lightning-deals`;
      } else if (searchTerm) {
        endpoint = `${BASE_URL}/api/customProducts/search?productName=${searchTerm}`;
      } else if (category && !subcategory && !isFilterClicked) {
        endpoint = `${BASE_URL}/api/customProducts/category?category=${category}`;
      } else if (subcategory) {
        endpoint = `${BASE_URL}/api/customProducts/subcategory?category=${
          selectedCategory || category
        }&subcategory=${subcategory}`;
        console.log("category", category);
      } else if (scheme === "offered") {
        endpoint = `${BASE_URL}/api/customProducts/offer-products`;
      } else if (scheme === "lightning") {
        endpoint = `${BASE_URL}/api/customProducts/lightning-deals`;
      } else if (isFiltered) {
        endpoint = `${BASE_URL}/api/customProducts/filterByPrice?minPrice=${tempValues[0]}&maxPrice=${tempValues[1]}`;
      } else if (!isFilterClicked && subcategory) {
        endpoint = `${BASE_URL}/api/customProducts/subcategory?subcategory=${subcategory}`;
      } else if (!isFilterClicked) {
        endpoint = `${BASE_URL}/api/customProducts/all`;
      }

      // Fetch the data
      const response = await axios.get(endpoint);
      let data = response.data || [];

      // Filter data based on stock status
      if (stockStatus === "inStock") {
        data = data?.filter((product) => product.productQuantity > 0);
      } else if (stockStatus === "outOfStock") {
        data = data?.filter((product) => product.productQuantity <= 0);
        // console.log("object", data);
      }

      setCurrentProducts(data);
      setCurrentPage(1);
    } catch (error) {
      console.error("Error fetching products", error);
      setCurrentProducts([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (sortByAlphabatically) {
      sortProductsByName();
    }
  }, [sortByAlphabatically]);

  const sortProductsByName = () => {
    const sortedProducts = [...currentProducts].sort((a, b) => {
      if (a.productName.toLowerCase() < b.productName.toLowerCase()) return -1;
      if (a.productName.toLowerCase() > b.productName.toLowerCase()) return 1;
      return 0;
    });

    setCurrentProducts(sortedProducts);
  };

  //------------------ pagination logic -----------------
  const fetchCartItems = async () => {
    const userId = localStorage.getItem("userId");
    if (userId) {
      try {
        const response = await axios.post(
          `${BASE_URL}/usercart/in-cart?userId=${userId}&pageSize=10000`
        );
        setCartItems(response.data);
      } catch (error) {
        console.error("Error fetching cart items:", error);
      }
    }
  };

  const fetchWishlistItems = async () => {
    const userId = localStorage.getItem("userId");
    if (userId) {
      try {
        const response = await axios.get(`${BASE_URL}/wishlist/get/${userId}`);
        setWishlistItems(response.data);
      } catch (error) {
        console.error("Error fetching wishlist items:", error);
      }
    }
  };

  const handleAddToCart = async (productId) => {
    const userId = localStorage.getItem("userId");
    if (userId) {
      try {
        await axios.post(
          `${BASE_URL}/usercart/add-product?userId=${userId}&productId=${productId}&orderQuantity=1`
        );
        await fetchCartCount();
        toast.success("Product added to cart");
        fetchCartItems(); // Refresh cart items
      } catch (error) {
        console.error("Error adding product to cart:", error);
        toast.error("Something went wrong! Try again later");
      }
    } else {
      navigate("/login");
    }
  };

  const handleAddToWishlist = async (productId) => {
    const userId = localStorage.getItem("userId");
    if (userId) {
      try {
        const wishlistResponse = await fetch(
          `${BASE_URL}/wishlist/add/${userId}`,
          {
            method: "POST",
            headers: {
              contentType: "application/json",
            },
            body: productId,
          }
        );
        setWishlistItems((prevWishlist) => [...prevWishlist, { productId }]);
        await fetchWishlistCount();
        toast.success("Product added to wishlist");
        fetchWishlistItems();
      } catch (error) {
        console.error("Error adding product to wishlist:", error);
        toast.error("Something went wrong! Try again later");
      }
    } else {
      navigate("/login");
    }
  };

  const removeWishlistItem = async (productId) => {
    const userId = localStorage.getItem("userId");
    try {
      const wishlistResponse = await axios.delete(
        `${BASE_URL}/wishlist/delete/${userId}/${productId}`
      );

      setWishlistItems((prevWishlist) =>
        prevWishlist.filter((item) => item.productId !== productId)
      );
      await fetchWishlistCount();
      toast.error("Product removed from wishlist");
      fetchWishlistItems();
    } catch (error) {
      console.error("Error removing product from wishlist:", error);
      toast.error("Something went wrong! Try again later");
    }
  };

  // Pagination logic
  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProductsPage = currentProducts.slice(
    indexOfFirstProduct,
    indexOfLastProduct
  );

  const totalPages = Math.ceil(currentProducts?.length / productsPerPage);
  const maxPages = 5;

  const startPage = Math.max(
    1,
    Math.floor((currentPage - 1) / maxPages) * maxPages + 1
  );
  const endPage = Math.min(startPage + maxPages - 1, totalPages);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleNextSet = () => {
    setCurrentPage((prev) => Math.min(prev + maxPages, totalPages));
  };

  const handlePrevSet = () => {
    setCurrentPage((prev) => Math.max(prev - maxPages, 1));
  };

  if (loading) {
    return <h2 style={{ color: "green" }}>Loading...</h2>;
  }

  return (
    <div>
      <div className="product-items">
        {currentProducts?.length > 0 ? (
          currentProducts?.slice(0, visibleCards).map((product) => (
            <div key={product.productId} className="product-card">
              <div className="product-image">
                {product.offered && <span className="offer-strip">OFFER</span>}
                <Link to={`/productdetails/${product.productId}`}>
                  <img
                    src={
                      product.prodImg1
                        ? product.prodImg1
                        : "https://balache-kapde-media.s3.ap-south-1.amazonaws.com/missing-picture-page-for-website-design-or-mobile-app-design-no-image-available-icon-vector.jpg"
                    }
                    alt={product.productName}
                    loading="lazy"
                  />
                </Link>
                <RxMagnifyingGlass
                  id="magnifying-glass-icon"
                  onClick={() => openModal(product.prodImg1)}
                />
                {isModalOpen && (
                  <div className="image-modal-overlay" onClick={closeModal}>
                    <div
                      className="image-modal-content"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <span className="image-modal-close" onClick={closeModal}>
                        ×
                      </span>
                      <img src={selectedImage} alt="Enlarged view" />
                    </div>
                  </div>
                )}
              </div>
              <div className="product-info">
                <p style={{ fontWeight: "bold", fontSize: "18px" }}>
                  {product.productName.slice(0, 10)}...{" "}
                  {product.productQuantity == 0 ? (
                    <span
                      style={{
                        color: "red",
                        fontSize: "13px",
                        float: "right",
                        // marginRight: "20px",
                        marginLeft: "auto",
                        display: "inline-block",
                        position: "relative",
                      }}
                    >
                      Out of Stock
                    </span>
                  ) : (
                    ""
                  )}
                </p>
                <div className="prod-price">
                  <span style={{ display: "flex", gap: "6px" }}>
                    <p
                      style={{
                        textDecoration: "line-through",
                        color: "gray",
                        fontSize: "15px",
                      }}
                    >
                      Rs {product.productMRP}
                    </p>
                    <p style={{ marginTop: "1px", fontSize: "18px" }}>
                      Rs {product.productRate}
                    </p>
                  </span>
                </div>

                <span className="d-flex">
                  {[...Array(5)].map((_, index) => (
                    <FaStar
                      key={index}
                      color={
                        index < Math.round(product.rating)
                          ? "#ffc35b"
                          : "#e4e5e9"
                      }
                    />
                  ))}

                  <span style={{ color: "black" }}>
                    ({product.no_of_rating}){" "}
                  </span>
                  {/* {[...Array(5)].map((_, i) => (
                    <MdOutlineStarPurple500
                      key={i}
                      style={{ color: "#ffc35b" }}
                      size={18}
                    />
                  ))} */}
                </span>

                {product.lightning && (
                  <div
                    className="ribbon-2"
                    style={{
                      position: "absolute",
                      top: "0px",
                      left: "10px",
                      fontSize: "12px", // Smaller font for mobile
                      padding: "2px 5px", // Adjust padding to fit
                      // backgroundColor: "orange",
                      // color: "white",
                      zIndex: "1",
                      margin: "2px",
                    }}
                  >
                    {" "}
                    Lightning Deal
                  </div>
                )}
                <div className="product-card-btn">
                  {product.productQuantity > 0 ? (
                    <button
                      className="add-to-cart"
                      onClick={() =>
                        navigate(`/productdetails/${product.productId}`)
                      }
                    >
                      Shop Now
                    </button>
                  ) : (
                    <button className="add-to-cart" disabled>
                      Out of Stock
                    </button>
                  )}
                  {wishlistItems.some(
                    (item) => item.productId == product.productId
                  ) ? (
                    <button
                      className="add-to-wishlist"
                      onClick={() => removeWishlistItem(product.productId)}
                    >
                      <FaHeart size={25} style={{ color: "red" }} />
                    </button>
                  ) : (
                    <button
                      className="add-to-wishlist"
                      onClick={() => handleAddToWishlist(product.productId)}
                    >
                      <FaRegHeart size={25} />
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))
        ) : (
          <h3 className="text-500">No products found</h3>
        )}
      </div>
      {/*<div className="pagination-container d-flex align-items-center justify-content-between">
        {currentProducts.length > 0 && (
          <h4 style={{ fontSize: "20px" }}>
            Showing {indexOfFirstProduct + 1} -{" "}
            {Math.min(indexOfLastProduct, currentProducts.length)} of{" "}
            {currentProducts.length} items
          </h4>
        )}

        <div className="pagination">
          {startPage > 1 && <button onClick={handlePrevSet}>...</button>}
          {Array.from({ length: endPage - startPage + 1 }, (_, index) => (
            <button
              key={startPage + index}
              onClick={() => handlePageChange(startPage + index)}
              className={startPage + index === currentPage ? "active" : ""}
            >
              {startPage + index}
            </button>
          ))}
          {endPage < totalPages && <button onClick={handleNextSet}>...</button>}
          {currentPage < totalPages && (
            <button onClick={() => handlePageChange(currentPage + 1)}>
              <MdKeyboardArrowRight />
            </button>
          )}
        </div>
      </div>*/}
      {visibleCards < currentProducts.length && (
        <div className="d-flex justify-content-center align-items-center">
          <button
            className="btn"
            style={{
              borderRadius: "5px",
              background: "goldenRod",
              color: "white",

              margin: "8px 0",
              marginBottom: "30px",
              width: "250px",
            }}
            onClick={handleLoadMore}
          >
            Load More
          </button>
        </div>
      )}
    </div>
  );
};

export default ProductsContainer;
